const ProjectSubstations = () =>
  import(/* webpackChunkName: "substations" */ '@/components/substations/substations-list');
const SubstationNew = () =>
  import(/* webpackChunkName: "substations" */ '@/components/substations/substation-new');
const SubstationEdit = () =>
  import(/* webpackChunkName: "substations" */ '@/components/substations/substation-edit');

const SUBSTATIONS_ROUTES = [
  {
    path: '/project/:projectCode',
    name: 'projectSubstations',
    component: ProjectSubstations,
    props: true
  },
  {
    path: '/project/:projectCode/substations/new',
    name: 'newSubstation',
    component: SubstationNew,
    props: true
  },
  {
    path: '/project/:projectCode/substation/:substationCode/edit',
    name: 'editSubstation',
    component: SubstationEdit,
    props: true
  }
];

export default SUBSTATIONS_ROUTES;
